import * as React from 'react';
import classnames from 'classnames';
import { useTranslate } from '@insolus/react-i18n';

var UnderConstruction = function UnderConstruction(_ref) {
  var title = _ref.title,
      message = _ref.message,
      className = _ref.className;

  var _useTranslate = useTranslate('ui-kit'),
      __ = _useTranslate.__;

  return React.createElement("div", {
    className: classnames(className, 'UnderConstruction')
  }, React.createElement("h1", {
    className: "UnderConstruction__title"
  }, title || __('under-construction.work-in-progress')), React.createElement("p", {
    className: "UnderConstruction__message"
  }, message || __('under-construction.feature-in-dev')));
};

UnderConstruction.defaultProps = {
  title: undefined,
  message: undefined,
  className: undefined
};
export default UnderConstruction;